import { Component, PropsWithChildren, ReactElement, ReactNode } from 'react';

 
export class ErrorBoundary extends Component<PropsWithChildren<{ fallback: ReactElement }>> {
    public fallback: ReactElement;
     
    public readonly state: { hasError: boolean } = { hasError: false };
    public constructor(properties: { children: ReactNode; fallback: ReactElement }) {
        super(properties);
        this.state = { hasError: false };
        this.fallback = properties.fallback;
    }

     
    public static getDerivedStateFromError(): { hasError: boolean } {
        return { hasError: true };
    }

     
    public componentDidCatch(error: Error, errorInfo: unknown): void {
         
        console.error(error, errorInfo);
    }

    public render(): ReactNode {
        const { children } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            return this.fallback;
        }

        return children;
    }
}
